import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import spaFace from "@/assets/spa-face-mask.webp";

const PaintBucketLoader = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsLoading(true);
    setIsVisible(true);

    const hideTimer = setTimeout(() => {
      setIsLoading(false);
    }, 800);

    const removeTimer = setTimeout(() => {
      setIsVisible(false);
    }, 1200);

    return () => {
      clearTimeout(hideTimer);
      clearTimeout(removeTimer);
    };
  }, [location.pathname]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] pointer-events-none flex items-center justify-center transition-opacity duration-400 ${
        isLoading ? "opacity-100" : "opacity-0"
      }`}
    >
      {/* Background fill */}
      <div
        className={`absolute inset-0 bg-white origin-top transition-transform duration-700 ease-out ${
          isLoading ? "animate-paint-fill" : "animate-paint-drain"
        }`}
      />

      {/* Spa face illustration */}
      <div className={`relative z-10 ${isLoading ? "animate-bucket-bounce" : ""}`}>
        <img
          src={spaFace}
          alt="Loading"
          className="w-24 h-24 md:w-32 md:h-32 object-contain"
        />
      </div>

      {/* Sparkle particles */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 rounded-full bg-background/80 animate-splash-particle"
            style={{
              left: `${25 + Math.random() * 50}%`,
              top: `${30 + Math.random() * 40}%`,
              animationDelay: `${i * 0.12}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default PaintBucketLoader;
